/**
 * Catalogue de l'onglet « Tutoriels Vidéo » de /tutoriels.
 * Extrait de src/pages/Tutoriels.tsx : les 9 tutos disponibles en tête,
 * puis les sujets encore « Vidéo à venir ».
 */
import { TUTOS, formatDuration, type TutoId, type VideoCategoryId } from './tutorial-catalog';

export type VideoTutorial = {
  id: string;
  title: string;
  description: string;
  duration: string;
  category: VideoCategoryId;
  /** Présent quand la vidéo existe ; absent = carte « Vidéo à venir ». */
  tutoId?: TutoId;
};

export const VIDEO_CATEGORIES: readonly { id: 'all' | VideoCategoryId; label: string }[] = [
  { id: 'all', label: 'Tous' },
  { id: 'getting-started', label: 'Prise en main' },
  { id: 'caisse', label: 'Caisse' },
  { id: 'chr', label: 'Restaurant & CHR' },
  { id: 'products', label: 'Produits' },
  { id: 'clients', label: 'Clients' },
  { id: 'reports', label: 'Rapports' },
  { id: 'config', label: 'Configuration' },
];

export function categoryLabel(id: VideoCategoryId): string {
  return VIDEO_CATEGORIES.find((c) => c.id === id)?.label ?? '';
}

const AVAILABLE: VideoTutorial[] = TUTOS.map((t) => ({
  id: t.id,
  title: t.title,
  description: t.description,
  duration: formatDuration(t.durationS),
  category: t.category,
  tutoId: t.id,
}));

const COMING_SOON: VideoTutorial[] = [
  {
    id: '2',
    title: 'Configurer votre commerce',
    description:
      'Renseignez les informations de votre société, paramétrez la TVA, les modes de règlement et les catégories.',
    duration: '6:15',
    category: 'getting-started',
  },
  {
    id: '3',
    title: 'Ouvrir et fermer une session de caisse',
    description:
      'Apprenez à ouvrir une caisse, saisir le fond de caisse, et fermer la session en fin de journée.',
    duration: '3:45',
    category: 'caisse',
  },
  {
    id: '6',
    title: 'Utiliser le scanner de code-barres',
    description:
      'Configurez votre douchette USB ou Bluetooth et scannez vos produits en caisse rapidement.',
    duration: '2:50',
    category: 'caisse',
  },
  {
    id: '9',
    title: 'Générer des images produits par IA',
    description:
      "Utilisez l'intelligence artificielle pour générer automatiquement des images pour vos produits.",
    duration: '2:30',
    category: 'products',
  },
  {
    id: '12',
    title: 'Campagnes Magic SMS',
    description:
      'Créez des templates SMS, ciblez vos clients par niveau de fidélité, et lancez vos campagnes.',
    duration: '4:25',
    category: 'clients',
  },
  {
    id: '16',
    title: 'Gérer les utilisateurs et les rôles',
    description:
      'Créez des comptes utilisateur, attribuez les rôles (admin, manager, caissier) et gérez les droits.',
    duration: '3:20',
    category: 'config',
  },
];

export const VIDEO_TUTORIALS: readonly VideoTutorial[] = [...AVAILABLE, ...COMING_SOON];
